// extracted by mini-css-extract-plugin
export default {"container":"Company_container__vh8Ko","accent":"Company_accent__VkIiR"};